<div class="absolute top-4 right-4 z-50">
    <mat-icon class="icon-size-8 cursor-pointer text-[#849a71]" (click)="sharedMethods.goHome()">close</mat-icon>
</div>
<div class="w-full background-paper min-h-screen py-32">
    <div class="w-full max-w-4xl mx-auto px-4">
        <!-- Sign In Card -->
        <div class="white-paper rounded-3xl shadow-md drop-shadow-lg p-8">

            <mat-stepper labelPosition="bottom" class="py-14 w-full bg-transparent max-w-[120rem] mx-auto"
                [orientation]="'horizontal'" #stepper>
                <mat-step label="Details">
                    <h1 class="text-3xl font-bold text-center mb-4">My Preferences</h1>
                    <form class="my-8 lg:px-8" [formGroup]="registerForm">
                        <div class="my-2 px-3">
                            <h1 class="text-xl font-bold"><i>Personal Details</i></h1>
                            <mat-form-field class="w-full rounded-lg mt-8" appearance="outline">
                                <mat-label class="font-bold text-lg">Name</mat-label>
                                <input id="name" class="text-xl" matInput [formControlName]="'name'" minlength="2">
                                <mat-error class="text-lg"
                                    *ngIf="registerForm.get('name')?.hasError('required') && registerForm.get('name')?.touched">
                                    Name is required
                                </mat-error>
                                <mat-error class="text-lg" *ngIf="registerForm.get('name')?.hasError('minlength')">
                                    Name must be at least 4 characters long
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="w-full rounded-lg mt-1" appearance="outline">
                                <mat-label class="font-bold text-lg">Surname</mat-label>
                                <input id="surname" class="text-xl" matInput [formControlName]="'surname'"
                                    minlength="2">
                                <mat-error class="text-lg"
                                    *ngIf="registerForm.get('surname')?.hasError('required') && registerForm.get('surname')?.touched">
                                    Surname is required
                                </mat-error>
                                <mat-error class="text-lg" *ngIf="registerForm.get('surname')?.hasError('minlength')">
                                    Surname must be at least 4 characters long
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </form>
                    <div class="mt-4 text-center">
                        <button class="fuse-mat-button-medium w-full mt-6 max-w-md mx-auto flex" mat-flat-button
                            color="primary" matStepperNext
                            [disabled]="registerForm.get('name')?.invalid || registerForm.get('surname')?.invalid">
                            <span class="text-white text-2xl font-bold">Continue</span>
                        </button>
                    </div>
                </mat-step>
                <mat-step label="Preferences">
                    <h1 class="text-3xl font-bold text-center mb-4">My Preferences</h1>
                    <form class="my-8 lg:px-8" [formGroup]="registerForm">
                        <div class="my-2 px-3">
                            <h1 class="text-xl font-bold font-italic mt-12"><i>Receive messages regarding</i></h1>
                            <div class="flex flex-row max-md:flex-col mt-6">
                                <mat-checkbox [formControlName]="'liveEvents'" (change)="liveEvents = !liveEvents">
                                    <h1 class="text-xl">
                                        Live events
                                    </h1>
                                </mat-checkbox>
                                <mat-checkbox [formControlName]="'experience'" (change)="experience = !experience">
                                    <h1 class="text-xl">
                                        Experience enhancements
                                    </h1>
                                </mat-checkbox>
                            </div>
                        </div>
                        <div class="flex flex-col  ">
                            <mat-checkbox [formControlName]="'terms'" class="mt-6 px-3" required
                                (change)="terms = !terms">
                                <h1 class="text-xl">
                                    <span class="mat-checkbox-label">
                                        <span style="display: none;">&nbsp;</span>
                                        <span class="font-bold">I have read and agree to the Terms of Service and
                                            Privacy
                                            Policy</span>
                                    </span>
                                </h1>
                            </mat-checkbox>
                            <div class="flex flex-row justify-start px-3 space-x-4 mt-4">
                                <a target="_blank" href="assets/pdfs/Terms.pdf"
                                    class="ml-1 text-primary-500 hover:underline text-xl font-bold"> Terms of Service
                                </a>
                                <a target="_blank" href="assets/pdfs/privacy-policy.pdf"
                                    class="ml-1 text-primary-500 hover:underline text-xl font-bold"> Privacy Policy </a>
                            </div>
                        </div>

                    </form>
                    <div class="mt-4 text-center">
                        <button class="fuse-mat-button-medium w-full mt-6  max-w-md mx-auto flex" mat-flat-button
                            [color]="'primary'" [disabled]="showSpinner || this.registerForm.invalid"
                            (click)="register()">
                            <span *ngIf="!showSpinner" class="text-white text-2xl font-bold ">
                                Continue
                            </span>
                            <mat-progress-spinner *ngIf="showSpinner" [diameter]="24" [mode]="'indeterminate'">
                            </mat-progress-spinner>
                        </button>
                    </div>
                </mat-step>

                 
            </mat-stepper>
        </div>
    </div>
</div>